import { useEffect, useState } from "react";
import { MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import MyPageShell, { EmptyState } from "../components/MyPageShell";

const STATUS_STYLE = {
    open: "text-amber-700 bg-amber-100",
    responded: "text-emerald-700 bg-emerald-100",
    closed: "text-navy-500/70 bg-navy-500/10",
};

export default function MyInquiries() {
    const [items, setItems] = useState(null);

    useEffect(() => {
        api.get("/inquiries/mine").then((r) => setItems(r.data || [])).catch(() => setItems([]));
    }, []);

    return (
        <MyPageShell title="My Enquiries" subtitle="Track everything you've asked a broker, seller or builder about." testid="my-inquiries-page">
            <div className="text-xs text-navy-500/60 mb-3">
                {items === null ? "Loading…" : `${items.length} enquir${items.length === 1 ? "y" : "ies"}`}
            </div>
            {items === null && <div className="py-12 text-center text-sm text-navy-500/50">Loading your enquiries…</div>}
            {items && items.length === 0 && (
                <EmptyState
                    icon={MessageSquare}
                    title="No enquiries yet"
                    message="Reach out to any property owner or broker — your conversations will show up here."
                    cta="Find properties"
                    to="/properties"
                    testid="inquiries-empty"
                />
            )}
            {items && items.length > 0 && (
                <ul className="space-y-3">
                    {items.map((i) => (
                        <li key={i.id} className="rounded-xl border border-navy-500/10 bg-white p-4" data-testid={`inquiry-item-${i.id}`}>
                            <div className="flex items-start justify-between gap-3">
                                <div className="flex-1 min-w-0">
                                    <Link to={i.property_id ? `/properties/${i.property_id}` : "#"} className="block font-heading font-bold text-navy-500 text-sm truncate hover:text-gold-700">
                                        {i.property_title || "Property enquiry"}
                                    </Link>
                                    <div className="text-[11px] text-navy-500/55 mt-0.5">
                                        Sent on {new Date(i.created_at).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" })}
                                    </div>
                                    {i.message && <p className="mt-2 text-[13px] text-navy-500/80 leading-relaxed line-clamp-2">{i.message}</p>}
                                </div>
                                <span className={`shrink-0 text-[10px] uppercase tracking-widest px-2 py-1 rounded-full font-bold ${STATUS_STYLE[i.status] || "text-navy-500/70 bg-navy-500/10"}`}>
                                    {i.status || "open"}
                                </span>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </MyPageShell>
    );
}
